import Text from './Text';
import styled, { css } from 'styled-components';

const StyledText = styled(Text)`
  font-style: italic;
  line-height: 1.37;
  text-decoration: underline;
  display: inline;
  ${({ footerText }) =>
    footerText &&
    css`
      display: inherit;
      padding-top: 26px;
    `}
`;

export default StyledText;
